module.exports = __webpack_public_path__ + "img/vmc_aniv26_24Aug2021.a1cd9cbf.jpg";